import { Session } from '../models/session.model';
import { createContext } from 'react';

export interface SessionContextType {
  session: Session | undefined;
  create: (session: Session, callback: VoidFunction) => void;
  destroy: (callback: VoidFunction) => void;
  refreshSession: () => void;
  isSessionLoading: boolean;
}

export const SessionContext = createContext<SessionContextType>({
  session: undefined,
  create: (session: Session, callback: VoidFunction) => {},
  destroy: (callback: VoidFunction) => {},
  refreshSession: () => {},
  isSessionLoading: false,
});
